import { EReportControlId } from '~/presentation/reports/common/type';
import { ReportFilterPanel, Visualization } from '../components';

export enum EReportLayout {
  Visualization = 'Visualization',
  ReportFilterPanel = 'ReportFilterPanel',
}

export const REPORT_LAYOUT = [
  {
    id: 'visualization',
    type: EReportLayout.Visualization,
  },
  {
    id: 'filter-panel',
    type: EReportLayout.ReportFilterPanel,
    props: {
      state: {
        [EReportControlId.METRICS_FILTER]: {
          hide: false,
          disabled: true,
        },
        [EReportControlId.DIMENSIONS_FILTER]: {
          hide: false,
          disabled: true,
        },
        [EReportControlId.CHART_FILTER]: {
          hide: false,
          disabled: true,
        },
        [EReportControlId.FILTER]: {
          hide: false,
          disabled: true,
        },
      },
    },
  },
];

export const getReportComponent = (type: EReportLayout) => {
  const components = {
    Visualization: Visualization,
    ReportFilterPanel: ReportFilterPanel,
  };

  return components[type];
};
